<template>
    <div class="PlatoMap">
        <template v-if="ready">
            <l-map
                :center.sync="center"
                :zoom.sync="zoom"
                :crs="crs"
                :bounds="mapBounds"
                :max-bounds="mapBounds"
                :min-zoom="0"
                :max-zoom="2"
                :options="mapOptions"
                ref="map"
            >
                <template v-for="layer in layers">
                    <l-image-overlay v-if="isLayerVisible(layer)" :url="layer.url" :bounds="layerBounds" :key="layer.id" />
                </template>
            </l-map>
        </template>
    </div>
</template>

<script>
    import { latLngBounds, CRS } from 'leaflet';
    import { LMap, LImageOverlay, LTileLayer, LMarker } from 'vue2-leaflet';
    import debounce from 'lodash/debounce';

    export default {
        components: {
            LMap,
            LImageOverlay,
            LTileLayer,
            LMarker
        },
        props: {
            layers: {
                type: Array,
                required: true,
            },
            current: Number,
            disabled: Boolean,
            options: Object
        },
        data() {
            return {
                ready: false,

                zoom: undefined,
                center: undefined,
                bounds: null,
                crs: CRS.Simple,
            }
        },
        computed: {
            mapOptions() {
                return {
                    zoomSnap: .5,
                    zoomDelta: 1,
                    zoomControl: false,

                    ...(this.disabled ? {
                        doubleClickZoom: false,
                        dragging: false,
                        scrollWheelZoom: false,
                    } : {}),

                    ...this.options
                }
            },
            mapBounds() {
                return latLngBounds(this.bounds).pad(.1);
            },
            layerBounds() {
                return latLngBounds(this.bounds).pad(-.05);
            },
        },
        methods: {
            isLayerVisible(layer) {
                return layer.id <= this.current;
            },
            async updateLayout() {
                const mapContainer = this.$el.parentElement;
                const width = mapContainer.offsetWidth;
                const height = mapContainer.offsetHeight;
                this.bounds = [[0, width], [height, 0]];
                await this.$nextTick();
                this.$refs.map.mapObject.fitBounds(this.mapBounds);
            },
        },
        mounted() {
            this.handleResize = debounce(this.updateLayout, 300);
            window.addEventListener('resize', this.handleResize);

            this.updateLayout();
            this.ready = true;
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        }
    }
</script>